import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { catalogBibShape, listShape, recommendationShape } from '@bibliocommons/bc-prop-types';
import Divider from '@bibliocommons/divider';

import RecommendationsContainer from './Recommendations/RecommendationsContainer';
import StaffListsContainer from './StaffLists/StaffListsContainer';

import './Discover.scss';

export default class Discover extends React.PureComponent {
  render() {
    const { catalogBib, staffLists, recommendations } = this.props;
    const metadataId = catalogBib.get('metadataId');

    if (!staffLists.size && !recommendations.size)
      return (
        <div className="container">
          <Divider />
        </div>
      );

    return (
      <section className="cp-bib-discover">
        <div className="container">
          <StaffListsContainer metadataId={metadataId} />
          {staffLists.size > 0 && recommendations.size > 0 && <Divider />}
          <RecommendationsContainer />
        </div>
      </section>
    );
  }
}

Discover.propTypes = {
  catalogBib: catalogBibShape.isRequired,

  // Props below are used to conditionally render the divider
  staffLists: ImmutablePropTypes.listOf(listShape).isRequired,
  recommendations: ImmutablePropTypes.listOf(recommendationShape)
};
